import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const tail = css`
  inline-size: ${spacing(66.75)};
  margin-inline-start: auto;
`
export const lead = css`
  padding-inline-start: ${spacing(5)};
`
